import React from "react";

type Props = {
  extension?: string;
  image: string;
  className?: string;
  style?: React.CSSProperties | undefined;
  imageType?: ImageTypes;
  isExternal?: boolean;
};

export enum ImageTypes {
  icon = "Icon",
  images = "Images",
}

export function getImagePath(
  image: string,
  extension = "png",
  imageType = ImageTypes.images,
  isExternal = false
) {
  if (isExternal) {
    return image;
  } else if (imageType === ImageTypes.images) {
    return `${process.env.PUBLIC_URL}/assets/images/${
      image ?? ""
    }.${extension}`;
  } else {
    return `${process.env.PUBLIC_URL}/assets/icons/${image ?? ""}.${extension}`;
  }
}

const TelescopeImage: React.FC<Props> = ({
  extension,
  image,
  className,
  style,
  imageType,
  isExternal,
}) => {
  return (
    <img
      className={`telescope-image ${className}`}
      style={style}
      src={getImagePath(image, extension, imageType, isExternal)}
      alt={image}
    />
  );
};

export default TelescopeImage;
